
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisLocatingDeviceActiveIec as ObiAisLocatingDeviceActiveIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-locating-device-active-iec.js';
 
 
 

 
 export const ObiAisLocatingDeviceActiveIec = createComponent({
   react: React,
   tagName: 'obi-ais-locating-device-active-iec',
   elementClass: ObiAisLocatingDeviceActiveIecElement,
   events: {
     
   }
  });
 
 